import { useQuery } from '@tanstack/react-query';
import { getAxios } from '../../../../lib/axios';
import { ApiEndpoints } from '../../../../constants/endpoints/apiEndpoints';
import { CompanyDivisionBookingOption } from '../types/companyDivisionBookingOption';

export const useCompanyDivisionBookingOptionsQuery = (companyId?: number | null) =>
  useQuery({
    queryKey: ['CompanyDivisionBookingOptions', companyId],
    enabled: companyId != null && companyId > 0,
    queryFn: async () =>
      (await getAxios().get<CompanyDivisionBookingOption[]>(ApiEndpoints.selectOptions.companies.divisions(companyId)))
        .data
  });
